import React from "react";
import { useSelector } from "react-redux";
import { constants } from "@qgiv/core-js";
import { findProductFromProductId } from "@qgiv/p2p-registration";
import { useFormikContext } from "formik";
import { selectCurrentProductId } from "../../../../redux/slices/productModalSlice";
import { selectAllProducts } from "../../../../redux/slices/productsSlice";
import { selectCmsControlByType } from "../../../../redux/slices/cmsSettingsSlice";
import ProductQuantity from "./ProductQuantity";

const ConnectedProductQuantity = () => {
    const {
        ENUMS: {
            CMS_Control: { P2P_STORE_PRODUCTS },
        },
    } = constants;

    const { values } = useFormikContext();
    const { Product_Quantity } = values;

    const currentProductId = useSelector(selectCurrentProductId);
    const products = useSelector(selectAllProducts);
    const product = findProductFromProductId(currentProductId, products);
    const {
        fieldData,
        purchaseLimit,
        hasAttributes = false,
        qtyAvail = 0,
        unlimited = true,
    } = product;

    const control = useSelector((state) =>
        selectCmsControlByType(P2P_STORE_PRODUCTS, state),
    );
    const {
        options: {
            quantityLabel = "Quantity",
            purchaseLimitMessage = "Limit of %PurchaseLimit% per purchase",
        },
    } = control;

    const entityReplacedPurchaseLimitMessage =
        purchaseLimit && Number(purchaseLimit) > 0
            ? purchaseLimitMessage.replace("%PurchaseLimit%", purchaseLimit)
            : "";

    const hasLimits = !!(purchaseLimit && Number(purchaseLimit) > 0);

    const getFieldDataIdFromAttributeSelection = () => {
        // Filters out just the Attributes from value object
        const attributeValuesToArray = Object.keys(values).filter(
            // eslint-disable-next-line no-bitwise
            (attributeKey) => ~attributeKey.indexOf("Attribute"),
        );

        const attributeValuesToFieldDataId =
            attributeValuesToArray &&
            attributeValuesToArray.map((attribute) => values[attribute]);

        const currentStrippedAlias =
            attributeValuesToFieldDataId.length > 0
                ? attributeValuesToFieldDataId
                      .reduce(
                          (previousValue, currentValue) =>
                              previousValue + currentValue,
                      )
                      .replace(/\s+/g, "") // Account for alias with spaces
                : "";

        const fieldDataId =
            fieldData &&
            Object.keys(fieldData).filter(
                (fieldKey) =>
                    String(fieldData[fieldKey].strippedAlias) ===
                    currentStrippedAlias,
            );

        return fieldDataId ? fieldDataId[0] : "";
    };

    const fieldDataId = getFieldDataIdFromAttributeSelection();

    const displayQuantityInput = purchaseLimit !== 1;

    // Get inventory available on page load
    // If no attributes, qtyAvail can be accessed from product top level
    // If product hasAttributes, we must find the fieldDataId then reach into the
    // fieldData to find specific attribute combo then access qtyAvail

    const getInventoryAvailFromAttributes = () =>
        product.fieldData[fieldDataId].qtyAvail;

    const hasInventory = !!(
        (hasAttributes &&
            fieldDataId &&
            !product.fieldData[fieldDataId].unlimited) ||
        (!hasAttributes && !unlimited)
    );

    const productQuantityProps = {
        displayQuantityInput,
        entityReplacedPurchaseLimitMessage,
        fieldDataId,
        hasLimits,
        hasInventory,
        Product_Quantity,
        purchaseLimit,
        quantityLabel,
        qtyAvail:
            hasAttributes && fieldDataId
                ? getInventoryAvailFromAttributes()
                : qtyAvail,
    };
    return <ProductQuantity {...productQuantityProps} />;
};

export default ConnectedProductQuantity;
